import { API } from '../Api';

// Marketplace (Ca) — danh mục, kho đồ, mua, gắn/tháo. Ca trừ từ số dư chính (User.Balance).
export interface StoreItem {
  id: string;
  code: string;
  type: 'Nametag' | 'AvatarEffect' | 'SuperVote' | 'ClanCreate' | 'ClanExpand' | 'DatingTurn' | string;
  name: string;
  description?: string | null;
  rarity?: string | null; // Common | Rare | Epic | Legendary | Mythic
  priceCa: number;
  durationDays?: number | null; // null = vĩnh viễn
  isConsumable: boolean;
  style?: string | null;
  assetUrl?: string | null;
  sortOrder: number;
  // Giới hạn phát hành + số liệu đã bán (toàn hệ thống) cho card FOMO.
  yearlyLimit?: number | null;
  monthlyLimit?: number | null;
  soldThisMonth?: number;
  soldThisYear?: number;
  ownerCount?: number;
}

export interface InventoryItem {
  id: string;
  storeItemId: string;
  type: string;
  name: string;
  style?: string | null;
  expiresAt?: string | null;
  quantity: number;
  isEquipped: boolean;
}

export interface StoreActionResult {
  success: boolean;
  message?: string | null;
  balanceAfter?: number | null;
}

export interface WalletSummary {
  balance: number;
  totalEarnedCa: number;
  totalSpentCa: number;
  lastAmountCa: number;
  lastLabel?: string | null;
}

// Cosmetic đang gắn (hiển thị cạnh tên/avatar). style: Nametag = mã màu hex; AvatarEffect = preset (glow/pulse/epic/legendary).
export interface Cosmetic {
  code: string;
  type: string;
  style?: string | null;
  assetUrl?: string | null;
  rarity?: string | null; // Mythic → có mintNumber
  mintNumber?: number | null; // số thứ tự 01..12 (chỉ Mythic)
}

export interface EquippedCosmetics {
  userId: string;
  nametag?: Cosmetic | null;
  avatarEffect?: Cosmetic | null;
}

const BASE = '/v1/payment-service/store';

export const getWalletSummary = () =>
  API.get<WalletSummary>(`${BASE}/wallet-summary`).then((r) => r.data);

// Số dư tách 2 ví (AML): Ca nạp (donate/mua) vs Ca thu nhập (rút/mua, không donate lại).
export interface UserBalanceBuckets {
  balance: number;
  available: number;
  topUpBalance: number;
  incomeBalance: number;
  minedBalance: number;
  /** Ca rút được ngay (đã qua hạn giữ, trừ lệnh đang chờ/đã rút) — cùng công thức máy chủ dùng khi tạo lệnh rút. */
  withdrawable?: number;
}
export const getUserBalanceBuckets = () =>
  API.get<UserBalanceBuckets>('/v1/payment-service/users/balance').then((r) => r.data);

export const getStoreItems = (type?: string) =>
  API.get<StoreItem[]>(`${BASE}/items`, { params: type ? { type } : {} }).then((r) => r.data);

export const getInventory = () =>
  API.get<InventoryItem[]>(`${BASE}/inventory`).then((r) => r.data);

export const purchaseStoreItem = (itemId: string, refUserId?: string) =>
  API.post<StoreActionResult>(`${BASE}/purchase`, { itemId, refUserId }).then((r) => r.data);

export const equipStoreItem = (inventoryId: string, equip: boolean) =>
  API.post<StoreActionResult>(`${BASE}/equip`, { inventoryId, equip }).then((r) => r.data);

export const getEquippedCosmetics = (userIds: string[]) =>
  API.post<EquippedCosmetics[]>(`${BASE}/equipped-cosmetics`, { userIds }).then((r) => r.data);
